export var DATA_SPACER = {
  // Bottom
  BOTTOM_25: "bottom-25",
  BOTTOM_50: "bottom-50",
  BOTTOM_100: "bottom-100",
  BOTTOM_150: "bottom-150",
  BOTTOM_200: "bottom-200",
  BOTTOM_300: "bottom-300",
  BOTTOM_400: "bottom-400",
  BOTTOM_500: "bottom-500",
  BOTTOM_600: "bottom-600",
  BOTTOM_700: "bottom-700",
  BOTTOM_800: "bottom-800",
  BOTTOM_900: "bottom-900",
  BOTTOM_1000: "bottom-1000",
  // Depreacted
  BOTTOM_BIG: "bottom-big",
  BOTTOM_HUGE: "bottom-huge",
  BOTTOM_LARGE: "bottom-large",
  BOTTOM_MAJOR: "bottom-major",
  BOTTOM_MEDIUM: "bottom-medium",
  BOTTOM_MINOR: "bottom-minor",
  BOTTOM_SMALL: "bottom-small",
  BOTTOM_TINY: "bottom-tiny",
  // Left
  LEFT_25: "left-25",
  LEFT_50: "left-50",
  LEFT_100: "left-100",
  LEFT_150: "left-150",
  LEFT_200: "left-200",
  LEFT_300: "left-300",
  LEFT_400: "left-400",
  LEFT_500: "left-500",
  LEFT_600: "left-600",
  LEFT_700: "left-700",
  LEFT_800: "left-800",
  LEFT_900: "left-900",
  LEFT_1000: "left-1000",
  // Deprecated
  LEFT_BIG: "left-big",
  LEFT_HUGE: "left-huge",
  LEFT_LARGE: "left-large",
  LEFT_MAJOR: "left-major",
  LEFT_MEDIUM: "left-medium",
  LEFT_MINOR: "left-minor",
  LEFT_SMALL: "left-small",
  LEFT_TINY: "left-tiny",
  // Right
  RIGHT_25: "right-25",
  RIGHT_50: "right-50",
  RIGHT_100: "right-100",
  RIGHT_150: "right-150",
  RIGHT_200: "right-200",
  RIGHT_300: "right-300",
  RIGHT_400: "right-400",
  RIGHT_500: "right-500",
  RIGHT_600: "right-600",
  RIGHT_700: "right-700",
  RIGHT_800: "right-800",
  RIGHT_900: "right-900",
  RIGHT_1000: "right-1000",
  // Deprecated
  RIGHT_BIG: "right-big",
  RIGHT_HUGE: "right-huge",
  RIGHT_LARGE: "right-large",
  RIGHT_MAJOR: "right-major",
  RIGHT_MEDIUM: "right-medium",
  RIGHT_MINOR: "right-minor",
  RIGHT_SMALL: "right-small",
  RIGHT_TINY: "right-tiny",
  // Top
  TOP_25: "top-25",
  TOP_50: "top-50",
  TOP_100: "top-100",
  TOP_150: "top-150",
  TOP_200: "top-200",
  TOP_300: "top-300",
  TOP_400: "top-400",
  TOP_500: "top-500",
  TOP_600: "top-600",
  TOP_700: "top-700",
  TOP_800: "top-800",
  TOP_900: "top-900",
  TOP_1000: "top-1000",
  // Deprecated
  TOP_BIG: "top-big",
  TOP_HUGE: "top-huge",
  TOP_LARGE: "top-large",
  TOP_MAJOR: "top-major",
  TOP_MEDIUM: "top-medium",
  TOP_MINOR: "top-minor",
  TOP_SMALL: "top-small",
  TOP_TINY: "top-tiny"
};